import React from "react";
import "./DeliveredMessagesModal.css";
import UserChip from "../../../../components/user-chip/UserChip";
import { formatDateTime } from "../../../../utils/formatDateTime";

interface User {
  email: string;
  id: string;
  lastName: string;
  firstName: string;
}

interface MessageData {
  users: User[];
  messageDetail: string;
  creatorName: string;
  createdAt: string;
  id: string;
}

interface DeliveredMessagesModalProps {
  isOpen: boolean;
  onClose: () => void;
  messageData: MessageData | null;
}

const DeliveredMessagesModal: React.FC<DeliveredMessagesModalProps> = ({
  isOpen,
  onClose,
  messageData,
}) => {
  console.log("messageData", messageData);

  if (!isOpen || !messageData) return null;

  const selectedUsers = messageData.users || [];

  return (
    <div className="dm-modal-overlay">
      <div className="dm-modal">
        <h3 className="dm-modal-title">Message</h3>

        <div className="dm-modal-content">
          {/* USERS */}
          <div className="dm-section">
            <p className="dm-label">Selected Users ({selectedUsers.length})</p>
            <div className="dm-users">
              {selectedUsers.map((user, i) => (
                <UserChip key={user.id || i} id={i} userName={user.firstName} />
              ))}
            </div>
          </div>

          {/* DATE & TIME */}
          <div className="dm-section-time">
            <p className="dm-label">Date & time :</p>
            <p className="dm-value">{formatDateTime(messageData.createdAt)}</p>
          </div>

          {/* CREATED BY */}
          <div className="dm-section-creator">
            <p className="dm-label">Created By :</p>
            <p className="dm-value">{messageData.creatorName}</p>
          </div>

          {/* MESSAGE */}
          <div className="dm-section">
            <p className="dm-label">Message</p>
            <p className="dm-message">{messageData.messageDetail}</p>
          </div>
        </div>

        <div className="dm-actions">
          <button className="dm-btn-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeliveredMessagesModal;
